module.exports = __webpack_public_path__ + "static/media/19ESCAP43.f0480c48.jpg";